import { getYear } from "date-fns";
import {
	type DatePanelStepDirection,
	YEARS_IN_DECADE,
} from "web_myplann/Shared/Components/FlatRow/datePanelHelpers";
import { getDecadeStart } from "web_myplann/Shared/Components/FlatRow/getDecadeStart";

export const isDecadeStepEnabled = (
	year: number,
	direction: DatePanelStepDirection,
	minDate?: Date,
	maxDate?: Date,
): boolean => {
	const targetStart = getDecadeStart(year) + direction * YEARS_IN_DECADE;
	const targetEnd = targetStart + YEARS_IN_DECADE - 1;
	const reachesMinimum = minDate === undefined || targetEnd >= getYear(minDate);
	const reachesMaximum =
		maxDate === undefined || targetStart <= getYear(maxDate);

	return reachesMinimum && reachesMaximum;
};
